/* ------------------------------------*\
    #FAV-BUTTON SCRIPT
\*------------------------------------ */

import Component from '../../../../../src/js/module/component';

/**
 * The FavoriteButton component controls a toggle-like favorite button
 * @extends Component
 */
export default class FavoriteButton extends Component {

    static componentName = 'fav-button';

    static componentSelector = '.js-fav-button';

    static defaultOptions = {};

    constructor() {
        super(...arguments);
        /**
         * Assign the click handler to the button element.
         */
        this.$$element.on('click', (event) => {
            event.preventDefault();
            // Clicking the button just inverts its `aria-pressed` state
            this.toggle();
        });
    }

    /**
     * Toggle the button state, namely the `.is-active` class.
     */
    toggle() {
        this.element.classList.toggle('is-active');
    }

}

FavoriteButton.register();
